import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from '../login/services/auth-service.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss']
})
export class ForgetPasswordComponent implements OnInit {
  // Public params
  loading = false;
  public person = {
    email: "",
  }
    constructor(private toastr:ToastrService, private auth:AuthServiceService, private router:Router) { }

  ngOnInit(): void {
  }

  onSubmit() {
    if (!this.person.email) {
      return this.toastr.error("Necesitas agregar un correo", "Error")
    }
    this.loading = true;
    this.auth.solicitarCambioPasswordByEmail(this.person.email).subscribe({
      next: (e) => {
        this.toastr.success("Correo Enviado")
        this.router.navigate(['login/password/sent']);
      },
      error: (_err) =>{
        this.toastr.error("El correo no es valido", "Error")
        this.loading = false;
      },
    })
  }
}
